import { checkoutConfig as staticConfig } from '../config/checkout'
import { api } from '../lib/api'

/** Resolve config — prefer live DB config, fall back to static file */
function cfg(liveConfig) {
  return liveConfig ?? staticConfig
}

/** Generate a unique invoice number: PREFIX-YYYYMM-XXXXX */
export function generateInvoiceNumber(liveConfig) {
  const prefix = cfg(liveConfig)?.invoice?.prefix ?? 'LL'
  const now = new Date()
  const yyyymm = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}`
  const rand = Math.floor(10000 + Math.random() * 90000)
  return `${prefix}-${yyyymm}-${rand}`
}

/** Format a Date (or an ISO date string, as returned by the API) as MM/DD/YYYY */
export function fmtDate(date = new Date()) {
  return new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date(date))
}

/** Format a Date or ISO string with its time, e.g. "Oct 30, 2026, 3:14 PM" */
export function fmtDateTime(date) {
  return new Intl.DateTimeFormat('en-US', { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(date))
}

/** Format a dollar amount */
export function fmtMoney(n, liveConfig) {
  const sym = cfg(liveConfig)?.invoice?.currencySymbol ?? '$'
  return `${sym}${Number(n).toFixed(2)}`
}

/** Build the full order object to be stored + passed to invoice */
export function buildOrder({ billingInfo, items, subtotal, bulkSavingsAmount = 0, discountCode, discountAmount, shipping, insuranceAmount = 0, insuranceLabel = null, preorderShippingFee = null, preorderShippingLabel = null, total, shipTogether = null, liveConfig }) {
  const c = cfg(liveConfig)
  const invoiceNumber = generateInvoiceNumber(liveConfig)
  const now = new Date()
  const dueDate = new Date(now)
  dueDate.setDate(dueDate.getDate() + (c?.invoice?.dueDays ?? 3))

  return {
    invoiceNumber,
    createdAt: now.toISOString(),
    dueAt: dueDate.toISOString(),
    status: 'pending',
    billingInfo,
    items,
    subtotal,
    bulkSavingsAmount,
    discountCode: discountCode ? discountCode.code : null,
    discountDescription: discountCode ? discountCode.description : null,
    discountAmount,
    shipping,
    insuranceAmount,
    insuranceLabel,
    preorderShippingFee,
    preorderShippingLabel,
    shipTogether,
    total,
  }
}

/** Persist order to the API. Returns { ok, viewToken } from the worker. */
export async function saveOrder(order) {
  return api.createOrder(order)
}

/** Load all orders from the API */
export async function loadOrders() {
  return api.getOrders()
}

/** Update an order's status via the API */
export async function updateOrderStatus(invoiceNumber, status) {
  await api.updateOrderStatus(invoiceNumber, status)
}
